import React from 'react';
import { MainMarketsColumn } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MainMarkets/MainMarketColumn';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    MainMarketsColumnTitle,
    MainMarketsTable,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MainMarkets/MainMarkets.style';
import { QuickPickViewState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { DateTime } from 'src_common/utils/time/time';

interface PlaceOnlyPropsType {
    userId: number;
    quickPickState: QuickPickViewState;
}

export const PlaceOnly = observer('PlaceOnly', (props: PlaceOnlyPropsType) => {
    const appState = useAppStateContext();
    const event = props.quickPickState.getSelectedEvent;

    if (event === null) {
        return null;
    }

    const competitionId = event.competition;

    const competition = appState.websocketV2.getCompetitionModel(competitionId);

    if (competition === null) {
        return null;
    }

    const startTime = DateTime.from(event.timeSettingsStartTime)?.tz(props.quickPickState.timeFilterState.timezone);

    return (
        <MainMarketsTable>
            <MainMarketsColumnTitle>
                {startTime?.format('HH:mm')}
                <br />
                <small>{competition.name}</small>
            </MainMarketsColumnTitle>
            {event.marketTopFinish.map((market) => (
                <MainMarketsColumn
                    key={market.id}
                    userId={props.userId}
                    eventId={event.id}
                    marketId={market.id}
                    quickPickState={props.quickPickState}
                />
            ))}
        </MainMarketsTable>
    );
});
